import styled from 'styled-components';
import colors from '../../styles/colors';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 30px 0 40px 0;
    background-color: ${colors.bgColorBlack2};
    color: white;

    /* Tutte le immagini partono dall alto e non dal centro*/
    & img {
        object-position: top;
    }
`;

const LineDivider = styled.div`
    width: 90%;
    height: 1px;
    background-color: ${colors.bgColorBlack2};
    margin: 20px 0;

    &.no-margin {
        margin: 2px;
    }
`;

const BoxAllSpecialMatches = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const ContainerBorderSpecialMatch = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    padding: 50px;
    margin: 10px 0 0 0;
    background: linear-gradient(160deg, rgba(163, 27, 27, 0.28) 0%, rgba(255, 255, 255, 0.07) 100%);
    border: 1px solid rgba(163, 27, 27, 0.35);
    border-radius: 10px;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    transition: all 0.22s ease;

    &:hover {
        transform: translateY(-3px);
        border-color: rgba(163, 27, 27, 0.65);
        box-shadow: 0 8px 28px rgba(163, 27, 27, 0.15), 0 4px 12px rgba(0, 0, 0, 0.4);
        color: white;
    }

    & img.belt-img-triple {
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
`;

const BoxSingleSpecialMatch = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    & img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
`;

const BoxTagSpecialMatch = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;

    & .team {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    & img.wrestler-img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }

    & img.belt-img-tag {
        width: 100px;
        height: 100px;
        object-fit: cover;
    }
`;

const BoxTripleSpecialMatch = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    & img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
`;

const BoxGenericSpecialMatch = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;

    & img.belt-img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }

    &.box-generic-special-match h6 {
        font-size: 25px;
    }

    &.box-generic-special-match img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
`;

const BoxInfoPpv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    
    & h6 {
        font-size: 20px;
    }

    & img.belt-img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }

    &.box-info-ppv-triple {
        margin-bottom: 10px;
    }

    &.box-info-ppv-triple h6{
        font-size: 16px;
    }
`;

const BoxAvatarWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const TopDecorColor = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: ${colors.bgColorBlack2};
    overflow: hidden;
`;

function WrestlerBestRandomMatches({ wrestlerData }: any) {
    const navigate = useNavigate();

    const navigateToPpv = (ppv: any) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }

    function renderSpecialMatch(match: any, key: any) {
        const typeMatch = match.type_match.type;

        switch (typeMatch) {
            case 'single':
                return (
                    <ContainerBorderSpecialMatch key={key}>
                        <TopDecorColor className="top-decor-color" />
                        <BoxSingleSpecialMatch className="box-single-special-match">

                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + match.wrestlers[0].avatar_path} alt={match.wrestlers[0].name} />
                                <h6>{match.wrestlers[0].name}</h6>
                            </BoxAvatarWrestler>

                            <BoxInfoPpv>
                                <h6>{match.ppv.ppv_description.name} {match.ppv.date.split('-')[2]}</h6>
                                <h6>{match.type_match.name}</h6>

                                {match.belt && 
                                    <>
                                        <img className="belt-img" src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.name} />
                                        <h6>{match.belt.name}</h6>
                                    </>
                                }
                            </BoxInfoPpv>

                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + match.wrestlers[1].avatar_path} alt={match.wrestlers[1].name} />
                                <h6>{match.wrestlers[1].name}</h6>
                            </BoxAvatarWrestler>

                        </BoxSingleSpecialMatch>
                    </ContainerBorderSpecialMatch>
                )
            case 'tag':
                return (
                    <ContainerBorderSpecialMatch key={key} onClick={() => navigateToPpv(match.ppv)}>
                        <TopDecorColor className="top-decor-color" />
                        <BoxTagSpecialMatch className="box-tag-special-match">

                            <div className="team team-1">
                                {/* Ciclo i wrestlers del match  */}
                                {match.wrestlers.map((wrestler: any, key: any) => (
                                    // Solo se team è 1 faccio vedere il nome del wrestler
                                    wrestler.pivot.team === 1 &&
                                    <BoxAvatarWrestler key={key}>
                                        <img className="wrestler-img" src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                                        <h6>{wrestler.name}</h6>
                                    </BoxAvatarWrestler>
                                ))}
                            </div>

                            <BoxInfoPpv>
                                <h6>{match.ppv.ppv_description.name} {match.ppv.date.split('-')[2]}</h6>
                                <h6>{match.type_match.name}</h6>

                                {match.belt && 
                                    <>
                                        <img className="belt-img-tag" src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.name} />
                                        <h6>{match.belt.name}</h6>
                                    </>
                                }
                            </BoxInfoPpv>

                            <div className="team team-2">
                                {match.wrestlers.map((wrestler: any, key: any) => (
                                    wrestler.pivot.team === 2 &&
                                    <BoxAvatarWrestler key={key}>
                                        <img className="wrestler-img" src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                                        <h6>{wrestler.name}</h6>
                                    </BoxAvatarWrestler>
                                ))}
                            </div>

                        </BoxTagSpecialMatch>
                    </ContainerBorderSpecialMatch>
                )
            case 'triple':
                return (
                    <ContainerBorderSpecialMatch key={key} onClick={() => navigateToPpv(match.ppv)}>
                        <TopDecorColor className="top-decor-color" />
    
                        <BoxInfoPpv className="box-info-ppv-triple">
                            <h6>{match.ppv.ppv_description.name} {match.ppv.date.split('-')[2]}</h6>
                            <h6>{match.type_match.name}</h6>
                            {match.belt && 
                            <>
                                <img className="belt-img-triple" src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.name} />
                                <h6>{match.belt.name}</h6>
                            </>
                        }
                        </BoxInfoPpv>

                        <BoxTripleSpecialMatch className="box-triple-special-match">
                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + match.wrestlers[0].avatar_path} alt={match.wrestlers[0].name} />
                                <h6>{match.wrestlers[0].name}</h6>
                            </BoxAvatarWrestler>
                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + match.wrestlers[1].avatar_path} alt={match.wrestlers[1].name} />
                                <h6>{match.wrestlers[1].name}</h6>
                            </BoxAvatarWrestler>
                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + match.wrestlers[2].avatar_path} alt={match.wrestlers[2].name} />
                                <h6>{match.wrestlers[2].name}</h6>
                            </BoxAvatarWrestler>
                        </BoxTripleSpecialMatch>

                        
                    </ContainerBorderSpecialMatch>
                )
            default:
                return (
                    <ContainerBorderSpecialMatch key={key} onClick={() => navigateToPpv(match.ppv)}>
                        <TopDecorColor className="top-decor-color" />
                        <BoxGenericSpecialMatch className="box-generic-special-match">
                            <BoxAvatarWrestler>
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestlerData.avatar_path} alt={wrestlerData.name} />
                                <h6>{wrestlerData.name}</h6>
                            </BoxAvatarWrestler>

                                <BoxInfoPpv>
                                    <h6>{match.ppv.ppv_description.name} {match.ppv.date.split('-')[2]}</h6>
                                    <h6>{match.type_match.type.charAt(0).toUpperCase() + match.type_match.type.slice(1)}</h6>
                                    <h6>{match.type_match.name}</h6>

                                    {match.belt && 
                                        <>
                                            <img className="belt-img" src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.name} />
                                            <h6>{match.belt.name}</h6>
                                        </>
                                    }
                                </BoxInfoPpv>
                            <img src={process.env.REACT_APP_STORAGE_URL + match.ppv.img_path} alt={match.ppv.ppv_description.name} />
                        </BoxGenericSpecialMatch>
                    </ContainerBorderSpecialMatch>
                )
        }
    }

    return (
        <Container>
            <h1>Match degni di nota</h1>
            <p>3 match casuali tra i più importanti della carriera</p>

            <BoxAllSpecialMatches>
                {wrestlerData.bestFights.map((match: any, key: any) => (
                    renderSpecialMatch(match, key)
                ))}
            </BoxAllSpecialMatches>
        </Container>
    )
}

export default WrestlerBestRandomMatches;